import { useQuery } from '@tanstack/react-query';
import type { EmailNotificationSettingsDto } from '../../../models/settings/admin/email-notification-settings.dto';
import apiRequest from '../../../services/apiWrapper';
import { EMAIL_NOTIFICATION_URL } from '../../../utils/constants/urlConstants';

async function getEmailNotificationSettings() {
  const response = await apiRequest.get<EmailNotificationSettingsDto>(
    EMAIL_NOTIFICATION_URL
  );

  return response.data;
}

export function useGetEmailNotificationSettings() {
  return useQuery({
    queryKey: ['email-notification-settings'],
    queryFn: getEmailNotificationSettings,
  });
}
